import React from 'react'
import { ClickablePopupCell } from './ClickablePopupCell'
import type { ClickablePopupColumnSettings, ClickablePopupOpenArgs } from './types'

const isBlank = (value: any) => value === null || value === undefined || value === ''

// $hintText: a smaller line under the value. Either a column name ('project')
// or a template with {column} placeholders ('Rejected ×{rejection_count}').
const hintTextValue = (hint: string, row: Record<string, any>) => {
	if (!hint.includes('{')) return row[hint]
	let hasValue = false
	const text = hint.replace(/\{([^}]+)\}/g, (_: string, field: string) => {
		if (!isBlank(row[field]) && Number(row[field]) !== 0) hasValue = true
		return row[field] ?? ''
	})
	return hasValue ? text : null
}

export function cellWithHintText(
	hints: Record<string, string>,
	dataField: string,
	render?: (cellInfo: any) => React.ReactNode
) {
	const hint = hints[dataField]
	if (typeof hint !== 'string' || !hint) return render
	return (cellInfo: any) => {
		const text = isBlank(cellInfo.data[dataField]) ? null : hintTextValue(hint, cellInfo.data)
		return (
			<div>
				<div>{typeof render === 'function' ? render(cellInfo) : cellInfo.text}</div>
				{text && <div className="clickable-popup-hint">{text}</div>}
			</div>
		)
	}
}

// $clickablePopups cell: a chip that opens the popup; values outside 'only' stay plain text
export function renderClickablePopupCell(args: {
	field: { dataField: string; caption?: string }
	settings?: ClickablePopupColumnSettings
	lookups: Record<string, any>
	onOpen: (popup: ClickablePopupOpenArgs) => void
}) {
	const { field, settings, lookups, onOpen } = args
	return (cellInfo: any) => {
		const { data } = cellInfo
		const value = data[field.dataField]
		const label = lookups[field.dataField]?.[value] ?? value
		const color = settings?.colors?.[value]
		const only = Array.isArray(settings?.only) ? settings?.only : null
		if (only && !only.includes(value)) {
			return (
				<span className="clickable-popup-text" style={color ? { color: color.color } : undefined}>
					{label}
				</span>
			)
		}
		return (
			<ClickablePopupCell
				value={value}
				label={label}
				color={color}
				onClick={() => onOpen({ field: field.dataField, caption: field.caption, data })}
			/>
		)
	}
}
